<template>
  <div class="useInfo-container app-container">
    <div class="useInfo-header bg-white">
      <!-- <div class="useInfo-header-top">
        <div>
          <p>机构数(个)</p>
          <p>3000</p>
        </div>
        <div>
          <p>设备数(个)</p>
          <p>3000</p>
        </div>
        <div>
          <p>用户数(人)</p>
          <p>13000</p>
        </div>
      </div> -->
      <div class="useInfo-header-bottom">
        <!-- <list-search @listSearchEvn="listSearchEvn" /> -->
        <div class="useInfo-header-bottom-date">
          <div class="booxCloud-date-select">
            <span
              v-for="item in dateType"
              :key="item.type"
              class="booxCloud-date-select-item"
              :class="{
                'booxCloud-date-select-active': type === item.type
              }"
              @click="changeType(item.type)"
              >{{ item.label }}</span
            >
          </div>
        </div>
      </div>
    </div>
    <div class="useInfo-main" v-bar>
      <div>
        <userLineChart v-if="usersData" :chartData="usersData">
          <div slot="button">
            <div class="booxCloud-date-select">
              <span
                v-for="item in areaType"
                :key="item.type"
                class="booxCloud-date-select-item"
                :class="{
                  'booxCloud-date-select-active': area === item.type
                }"
                @click="changeAreaType(item.type)"
                >{{ item.label }}</span
              >
            </div>
          </div>
        </userLineChart>
        <modelLineChart v-if="devicesData" :chartData="devicesData" />
        <storageLineChart v-if="storageData" :chartData="storageData" />
      </div>
    </div>
  </div>
</template>

<script>
import userLineChart from "./components/userLineChart";
import modelLineChart from "./components/modelLineChart";
import storageLineChart from "./components/storageLineChart";
// import listData from "./components/listData";
export default {
  components: {
    userLineChart,
    modelLineChart,
    storageLineChart
    // listData
  },
  data() {
    return {
      usersData: null,
      devicesData: null,
      storageData: null,
      type: "day",
      area: "users-prod",
      params: {
        type: "day"
      },
      userParams: {
        type: "day"
      },
      areaType: [
        {
          type: "users-prod",
          label: "国内"
        },
        {
          type: "users-us",
          label: "国外"
        }
      ],
      dateType: [
        {
          type: "day",
          label: "天"
        },
        {
          type: "week",
          label: "周"
        },
        {
          type: "month",
          label: "月"
        },
        {
          type: "year",
          label: "年"
        }
      ]
    };
  },
  methods: {
    changeType(type) {
      if (this.type === type) return;
      this.type = type;
      this.params.type = type;
      this.userParams.type = type;
      this.getUserByDate();
      this.getDeviceByDate();
      this.getStorageByDate();
    },
    changeAreaType(type) {
      if (this.area === type) return;
      this.area = type;
      this.userParams.index = type;
      this.getUserByDate();
      // this.getDeviceByDate();
      // this.getStorageByDate();
    },
    async getUserByDate() {
      try {
        let res = await this.$http.userByDate(this.userParams);
        this.usersData = res.data;
      } catch (error) {
        throw error;
      }
    },
    async getDeviceByDate() {
      try {
        let res = await this.$http.deviceByDate(this.params);
        this.devicesData = res.data;
      } catch (error) {
        throw error;
      }
    },
    async getStorageByDate() {
      try {
        let res = await this.$http.storageByDate(this.params);
        this.storageData = res.data;
      } catch (error) {
        throw error;
      }
    }
  },
  mounted() {
    this.getUserByDate();
    this.getDeviceByDate();
    this.getStorageByDate();
  }
};
</script>

<style lang="scss">
.useInfo-container {
  .useInfo-header {
    padding: 10px 50px;
    .useInfo-header-top {
      display: flex;
      justify-content: space-around;
      padding: 20px 0 30px;
      border-bottom: 1px solid $globalBorderColor;
    }
    .useInfo-header-bottom {
      display: flex;
      justify-content: flex-end;
      margin-top: 20px;
      .useInfo-header-bottom-date {
        display: flex;
        align-items: center;
        .booxCloud-date-select {
          .booxCloud-date-select-item {
            display: inline-block;
            padding: 6px 12px;
            margin-left: 20px;
            font-size: 14px;
            border-radius: 4px;
            border: none;
            outline: none;
            cursor: pointer;
            -webkit-transition: all 0.3s;
            transition: all 0.3s;
            background: #ccc;
            color: #fff;
          }
          .booxCloud-date-select-active {
            background: #bf735b;
            color: #fff;
          }
        }
      }
    }
  }
  .booxCloud-date-select {
    .booxCloud-date-select-item {
      display: inline-block;
      padding: 6px 12px;
      margin-left: 20px;
      font-size: 14px;
      border-radius: 4px;
      border: none;
      outline: none;
      cursor: pointer;
      -webkit-transition: all 0.3s;
      transition: all 0.3s;
      background: #ccc;
      color: #fff;
    }
    .booxCloud-date-select-active {
      background: #bf735b;
      color: #fff;
    }
  }
  .useInfo-main {
    flex: 1;
    padding: 20px;
    overflow: hidden;
  }
}
</style>
